/**
 * PATH: packages/job-hub/src/jobs/access/useJobAccessMeta.ts
 * FILE_ID: JOBHUB-JOBS-ACCESS-HOOK-001
 * PURPOSE: Single TanStack query for GET /jobs/:id/access on Django mounts.
 * WHY: JobTeamAccessSection and JobHubPage must not each invent access polls.
 */
import { useQuery } from '@tanstack/react-query'
import { useJobHubDataAdapter } from '../jobHubDataAdapter'
import { isJobTeamAccessHost } from './resolveEffectiveJobCapabilities'
import type { JobAccessMeta } from './types'

export function jobAccessQueryKey(jobId: string | number) {
  return ['job-access', String(jobId)] as const
}

export function useJobAccessMeta(jobId: string | number | null | undefined) {
  const { client, capabilities } = useJobHubDataAdapter()
  const enabled = jobId != null && jobId !== '' && isJobTeamAccessHost(capabilities)

  return useQuery<JobAccessMeta>({
    queryKey: jobAccessQueryKey(jobId ?? 'none'),
    enabled,
    queryFn: () => client.get(`/jobs/${jobId}/access`).then((r) => r.data as JobAccessMeta),
  })
}
